export default __webpack_public_path__ + "static/media/medical_18.56d5a7ae.jpg";